// extracted by mini-css-extract-plugin
module.exports = {"header":"title_header__3ncaa","title_content":"title_title_content__CLI2X","title":"title_title__f2PuK","info":"title_info__1Oyaf"};